module.exports = __webpack_public_path__ + "img/IMG_1149_L_BlackMatted_MockedUp.539cba78.jpg";